/*
 * @Author: Teemo Ding
 * @Date: 2021-09-30 09:37:41
 * @LastEditTime: 2021-10-08 14:23:44
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/tax.ts
 */

export enum TaxInclusionType {
  Inclusive = 'Inclusive',
  Exclusive = 'Exclusive',
  Free = 'Free',
}

export enum TaxApplyType {
  All = 'All',
  HsCode = 'HsCode',
  Specific = 'Specific',
  Shipping = 'Shipping',
  Order = 'Order',
}
